// npoimport { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-between">
        <Col xl="12">
          <div className="copyright text-center  text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://edushalaacademy.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
            Edushala Academy
            </a>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;